<template>
  <div id="step-teleconsulta">
    <div class="container-text">
      <div>
        <span class="title">O que é uma teleconsulta ?</span>
        <p class="paragraph p-width">A teleconsulta é uma forma de atendimento médico por video.
        Uma forma de atender casos mais simples sem a necessidade que você saia de casa.</p>
      </div>
      <div class="img">
        <inline-svg :src="require('@/assets/img/img_helper_teleconsulta1.svg')"></inline-svg>
      </div>
    </div>
    <div class="text">
      <span class="title">O que é necessário?</span>
      <ul>
        <li class="list" v-for="(item, i) in instrucoes" :key="i">{{item}}</li>
      </ul>
    </div>
    <div class="text-last">
      <span class="title">Instale o aplicativo</span>
      <p class="paragraph">Sua teleconsulta irá ocorrer através do nosso aplicativo “Portal Saúde”.
        Nele você terá muitas outras facilidades e é uma ferramenta de suma importância para você, beneficiário.</p>
      <p class="paragraph">O aplicativo é gratuito e está disponível para iPhone e Android. Toque abaixo para instalar.</p>
    </div>
    <div style="margin-top: 20px">
      <img style="margin-right: 6px;" :src="require('@/assets/img/img_download_ios.png')"/>
      <img :src="require('@/assets/img/img_download_android.png')"/>
    </div>
    <el-button
      @click="nextStep"
      :style="`background:${corBotaoPrincipal};
      color: ${corTextoBotaoPrincipal}`"
      class="btn-primary">
      PRÓXIMO
    </el-button>
  </div>
</template>
<script>
import InlineSvg from 'vue-inline-svg'
import { mapGetters, mapState } from 'vuex'
export default {
  components: {
    InlineSvg
  },
  data () {
    return {
      instrucoes: [
        'Um smartphone Android ou iPhone',
        'Conexão à internet via wi-fi ou 4G',
        'Ter o aplicativo “Portal Saúde” instalado em seu smartphone.'
      ]
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['funcionalidade']),
    corBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    idTermoUsoVideo () {
      return this.funcionalidade.parametros.idTermoUsoConsultaVideo
    }
  },
  methods: {
    nextStep () {
      this.$router.push({ path: '/53/TermosDeUso/', query: { id: `${this.idTermoUsoVideo}` } })
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif&display=swap');
.paragraph, .list {
  font-family: 'Noto Serif', serif;
}
.p-width {
  width: 365px;
}
</style>
